export const getters = {

  systemEmployees: state => state.employees,
  Employee: state => state.systemEmployee
}
export default getters



// WEBPACK FOOTER //
// ./src/vuex/modules/employees/getters.js